import React from 'react';

import yinYangCat from '../img/yinyang10.png';

export default function Home() {
  return (
    <>
      <img src={yinYangCat} className='logoImg float-right right-floated-spacer' alt=''/>
      <h1>
        What is MeowDAO?
      </h1>
      <p>
        MeowDAO is a decentralized autonomous organization created to look after the welfare of animals.
        To fulfill that mission, the MeowDAO governance token was made. This ERC20 token functions as
        a fully decentralized, autonomous charity by allowing each token to represent a vote. Holders of
        the token can stake their wallets and vote for the cause they see appropriate. The winning
        address will receive tokens that are generated from the staked wallets. Stakers also receive
        tokens for taking on this role.
      </p>
      <h1>
        About this website
      </h1>
      <p>
        Because the DAO is directly composed of the token holders, this website is intended to act as a basic user interface instead of a traditional sales page.
        Holders are encouraged to take responsibility for the future of the DAO to mold it however they see fit.
      </p>
    </>
  )
}
